import React, {Component} from "react"
import PropTypes from "prop-types"

import {EmojiButton, FullEmojiPicker} from "./"

class TextAreaEmojiPicker extends Component {
  static propTypes = {
    cursorPosition: PropTypes.number.isRequired,
    hasError: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    showFullEmojiPicker: PropTypes.bool.isRequired,
    togglePickerModal: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
  }

  addEmojiToValue = (newValue) => {
    const {cursorPosition, onChange, value} = this.props

    const textBeforeCursor = value.substring(0, cursorPosition)
    const textAfterCursor = value.substring(cursorPosition, value.length)

    onChange({
      target: {
        value: `${textBeforeCursor}${newValue}${textAfterCursor}`
      }
    })
  }

  render() {
    const {hasError, showFullEmojiPicker, togglePickerModal} = this.props

    return (
      <div>
        <EmojiButton hasError={hasError} togglePickerModal={togglePickerModal} />
        {showFullEmojiPicker && (
          <FullEmojiPicker
            onSelect={(emoji) => {
              this.addEmojiToValue(emoji.native)
              togglePickerModal()
            }}
            togglePickerModal={togglePickerModal}
          />
        )}
      </div>
    )
  }
}

export default TextAreaEmojiPicker
